module.exports = __webpack_public_path__ + "img/pc_banner_sup_faq.1490209c.webp";